// extracted by mini-css-extract-plugin
export default {"headerlink":"linkButton_headerlink__wZgDD"};